import { createBootstrap } from "../../bootstrap";

export default createBootstrap("institution");
